import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { InboxService } from 'app/inbox/inbox.service';
import { ConfigService } from 'app/shared/services/config.service';
import { Subscription } from 'rxjs';
import { Mail, Message } from './../inbox.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-tickets-view',
  templateUrl: './tickets-view.component.html',
  styleUrls: ['./tickets-view.component.scss'],
  providers: [InboxService]

})
export class TicketsViewComponent implements OnInit {

 
  placement = "bottom-right";
  public innerWidth: any;

  editorModel = [{
    attributes: {
      font: 'roboto'
    },
    insert: 'test'
  }]

  public config: any = {};
  layoutSub: Subscription;

  searchQuery: string = '';
  activeTypeButton: string = "Inbox";
  isContentOverlay = false;
  isEmailSidebarShow = false;
  isComposeShow = false;
  selectedMailId: number = 4;
  isEmailImportant: boolean = false;
  public isCollapsed = true;
  public isCollapsed1 = false;
  public isMessageSelected = true;
  closeResult: string;
  mail: Mail[];
  message: Message;

  myForm: FormGroup;
  current_date: any
  time: any
  budget_val: any
  normal_priority = '643e823159b78b65557d74ab'
  medium_priority = '643e84ec59b78b65557d7526'
  high_priority = '643e851c59b78b65557d752d'
  urgent_priority = '643e854959b78b65557d7534'
  isEmpList: boolean = false
  isTeamList: boolean = false
  isStudentList: boolean = false
  isBatchList: boolean = false
  isScheduleList: boolean = false
  isPriorityList: boolean = false
  isType: boolean = false
  isTaskLabel: boolean = false
  isTime: boolean = false
  isBudget: boolean = false
  isDueDate: boolean = false
  isMandatory: boolean = false
  isEmployee: boolean = false
  isStudent: boolean = false
  isProjectList: boolean = false
  isCheckList: boolean = false
  isLeadType: boolean = false
  isTrainingLead: boolean = false
  isOutsourceLead: boolean = false
  isTeam_selected_list: boolean = false
  isBatch_selected_list: boolean = false

  team_selected_list = []
  team_selected_list_data: string[] = [];
  batch_selected_list = []
  batch_selected_list_data: string[] = [];
  empList = []
  teamList = []
  studentList = []
  batchList = []
  selectTeam: string[] = [];
  selectedEmp: string[] = [];
  selectedStudent: string[] = [];
  selectedBatch: string[] = [];
  selectedSchedule = null
  selectedMandatory = null
  selectedTaskLabel = null
  selectedType = null
  teamId = "631ad9d8ce5c666542591bee"

  isAllSelected = false;

  scheduleList = [
    { name: 'All', id: 'all' },
    { name: 'One Time', id: 'oneTime' },
    { name: 'Twice in a day', id: 'twice_in_a_day' },
    { name: 'Once in a day', id: 'once_in_a_day' },
    { name: 'Weekly', id: 'weekly' },
    { name: 'Bi-Weekly', id: 'bi_weekly' },
    { name: 'Monthly', id: 'monthly' },
    { name: 'Half-Yearly', id: 'half_yearly' },
    { name: 'Yearly', id: 'yearly' }

  ]
  mandatoryList = [
    { name: 'No', id: 'no' },
    { name: 'Yes', id: 'yes' },
  ]
  typeList = [
    { name: 'Ticket', id: 'ticket' },
    { name: 'Projects', id: 'projects' },
    { name: 'Leads', id: 'leads' },
    { name: 'Checklist', id: 'checklist' },
    { name: 'Message', id: 'message' }
  ]
  taskLabelList = []

  leads_type = [
    { name: 'Training', id: 'training' },
    { name: 'Outsource', id: 'outsource' },
  ]
  select_leadType = null

  task_label_catId = '643e7f6f59b78b65557d744a'
  task_priority_catId = '643e7faf59b78b65557d744e'
  task_priority_List = []
  selected_task_priority = '643e823159b78b65557d74ab'

  selectedItemCount: number = 0;

  project_list = []
  select_project: string[] = [];
  check_list = []
  select_checklist: string[] = [];
  training_list = []
  outsource_list = []
  select_training_lead : string[] = []
  select_outsource_lead :  string[] = []
  task_for_selected: any
  isDropdownOpen: boolean = false
  isDropdownOpen_student: boolean = false
  isDropdownOpen_employee: boolean = false
  taskDetail: any
  taskId: any

  task_stage_cat_id ='64ae4427e0a6ff2e7db7830e'
  task_status_cat_id ='643e806559b78b65557d7456'

  task_stage_list =[]
  task_status_list =[]
  activeTab = "open"

  task_data =[]
  current_task_data:any
  isCurrentTask: Boolean
  
  @ViewChild('name') inputName;
  total_count:any

  searchVal = ''
  selected_user_id ='all'
  selected_priority_id='all'
  selected_label_id =''
  selected_stage_id ='all'
  selectedSchedule_filter = 'all'
  saved_filter_list =[]
  user_id:any
  activeFilterIndex: number | null = null;
  constructor(private elRef: ElementRef, private renderer: Renderer2,
    private modalService: NgbModal, private inboxService: InboxService,
    @Inject(DOCUMENT) private document: Document, private configService:ConfigService,
    private cdr: ChangeDetectorRef,private apiService: ApiService, public toastr: ToastrService,
    private formBuilder: FormBuilder,private route: Router,private activerouter: ActivatedRoute,
    private spinner: NgxSpinnerService) {
      this.user_id = JSON.parse(localStorage.getItem('user')).id;
      this.getAllEmployee()

    this.mail = this.inboxService.inbox.filter((mail: Mail) => mail.mailType === 'Inbox');
    this.message = this.inboxService.message.filter((message: Message) => message.mailId === this.selectedMailId)[0];
    this.markAsRead();
    this.checkEmailImportantStatus();
    this.config = this.configService.templateConf;
    this.renderer.addClass(this.document.body, "email-application");

    this.selectedType = 'ticket'
    this.selectedSchedule = 'oneTime'
    this.selectedMandatory = 'no'
    this.current_date = this.getCurrentDate()
    this.time = 1
    this.budget_val = 0

  }

  ngOnInit() {

    this.getTaskStageList()
    this.getEmployeeCategory()
    this.getAllStudents()
    this.getAllBatch()
    this.getTaskPriorityList()
    this.getTaskLabelList()
    this.getTaskStatusList()
    this.getCurrentUserFilter(this.user_id)
    this.activeStatusTab('open')



    this.innerWidth = window.innerWidth;
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_student = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_employee = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isScheduleList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isPriorityList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isTaskLabel = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isMandatory = false;
      }
    });
    this.isEmployee = true;
    this.isEmpList = true;
    this.task_for_selected = 'employee'
    this.myForm = this.formBuilder.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      type: ['', Validators.required],
      due_date: [this.current_date,],
      body: ['',],
      time: [this.time,],
      budget: [this.budget_val,],
    });

   
  }

  ngAfterViewInit() {
    if(this.innerWidth < 768) {
      this.isMessageSelected = false;
    }

  }
  activeStatusTab(tab){
      const activetab = tab;
      this.activeTab = tab
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activerouter, queryParams: { status: activetab } }
        );
      }
   
  }
  setAndGetByStatus() {
    
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          case 'open':
            this.isCurrentTask=false
            this.getTaskByStatusList();
            break;
          case 'inprogress':
            this.isCurrentTask=false
            this.getTaskByStatusList();
            break
          case 'closed':
            this.isCurrentTask=false
            this.getTaskByStatusList();
            break;
           default:
            this.activeTab = ''
        }
      })
  }
  getTaskByStatusList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
      let status = this.task_status_list.find((item) => item.name == this.activeTab)
      this.apiService.getTaskDataByFilterId("",status._id,this.selected_stage_id || 'all',this.selected_user_id || 'all',
        this.selected_priority_id || 'all',this.selectedSchedule_filter || 'all',this.searchVal,1,1000).subscribe((res:any)=>{
            this.spinner.hide()
            this.task_data = res?.data?.items
            this.total_count = res?.data?.totalCount
        })  
  }
  filterTask(val) {
    this.apiService.taskSearch(val).subscribe((res: any) => {
      this.task_data =res?.data?.items
     })
  }
  resetFilter(){
    this.inputName.nativeElement.value = null;
    this.setAndGetByStatus()
  }
  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    this.renderer.removeClass(this.document.body, "email-application");
  }

  markAsRead() {
    let updateItem = this.mail.find(item => item.mailId.toString() === this.selectedMailId.toString());
    let index = this.mail.indexOf(updateItem);
    this.mail[index].isRead = true;
  }

  markAsUnread() {
    let updateItem = this.mail.find(item => item.mailId.toString() === this.selectedMailId.toString());
    let index = this.mail.indexOf(updateItem);
    this.mail[index].isRead = false;
  }

  markAsImportant() {
    let updateItem = this.mail.find(item => item.mailId.toString() === this.selectedMailId.toString());
    let index = this.mail.indexOf(updateItem);
    this.mail[index].isImportant = true;
    this.isEmailImportant = true;
  }

  markAsUnimportant() {
    let updateItem = this.mail.find(item => item.mailId.toString() === this.selectedMailId.toString());
    let index = this.mail.indexOf(updateItem);
    this.mail[index].isImportant = false;
    this.isEmailImportant = false;
  }

  checkEmailImportantStatus() {
    let selectedEmail = this.mail.find(item => item.mailId.toString() === this.selectedMailId.toString());
    this.isEmailImportant = selectedEmail.isImportant;
  }



  //inbox user list click event function
  DisplayMessage(mailId: number) {
    this.selectedMailId = mailId;
    this.message = this.inboxService.message.filter((message: Message) => message.mailId.toString() === mailId.toString())[0];
    this.isMessageSelected = true;
    this.markAsRead();
    this.checkEmailImportantStatus();
  }

  //compose start
  compose(show) {
    this.isComposeShow = show;
    this.isEmailSidebarShow = false;
    if(!show) {
      this.isContentOverlay = false;
    }
    else{
      this.isContentOverlay = true;
    }
  }


  //inbox labels click event function
  GetEmailsByLabel(labelType: string) {
    this.mail = this.inboxService.inbox.filter((mail: Mail) => mail.labelType === labelType);
    this.activeTypeButton =  labelType;
  }

  //inbox type click event function
  GetEmailsByType(type: string) {
    this.mail = this.inboxService.inbox.filter((mail: Mail) => mail.mailType === type)
    this.activeTypeButton =  type;
  }

  //inbox Starred click event function
  GetStarredEmails() {
    this.mail = this.inboxService.inbox.filter((mail: Mail) => mail.isImportant === true);
    this.activeTypeButton =  'Starred';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if(this.innerWidth < 768) {
      this.isMessageSelected = false;
    }
    if(this.innerWidth > 768) {
      this.isMessageSelected = true;
    }
  }

  onListItemClick() {
    this.isMessageSelected = true;
  }

  OnBackToInbox() {
    this.isMessageSelected = false;
  }

  onSidebarToggle() {
    this.isContentOverlay = true;
    this.isEmailSidebarShow = true;
  }

  onContentOverlay() {
    this.isContentOverlay = false;
    this.isEmailSidebarShow = false;
    this.isComposeShow = false;

  }
  getTaskStatusList() {
    this.apiService.getTagByTagCatgoryId(this.task_status_cat_id).subscribe((res: any) => {
      this.task_status_list = res.data
      this.setAndGetByStatus()
    })
  }
  getTaskStageList() {
    this.apiService.getTagByTagCatgoryId(this.task_stage_cat_id).subscribe((res: any) => {
      this.task_stage_list = res.data
      this.task_stage_list.push({ displayname: 'All', _id: 'all' },)
    })
  }
  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = this.padNumber(today.getMonth() + 1);
    const day = this.padNumber(today.getDate());
    return `${year}-${month}-${day}`;
  }
  padNumber(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }
  openModal(content,) {

    const modalRef = this.modalService.open(content);

    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  getChangeTypeId(event) {
    this.selectedType
    if (event.name == 'Projects') {
      this.isProjectList = true
      this.isCheckList = false
      this.isLeadType = false
      this.getProjectList()
    }
    if (event.name == 'Checklist') {
      this.isCheckList = true
      this.isLeadType = false
      this.isProjectList = false
      this.getCheckList()
    }
    if (event.name == 'Leads') {
      this.isLeadType = true
      this.isProjectList = false
      this.isCheckList = false
    }
  }
  getProjectList() {
    this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36', 1, 100, '', 'current').subscribe((res: any) => {
      this.project_list = res.data.items
    })
  }
  getProjectId(event) {
    this.select_project
  }
  getCheckList() {
    this.apiService.getAllChecklist(1, 100,'').subscribe((res: any) => {
      this.check_list = res.data.items
    })
  }
  getCheckListId(event) {
    this.select_checklist
  }
  getLeadTypeId(event) {
    this.select_leadType
    if (event.name === 'Training') {
      this.isTrainingLead = true
      this.getTrainingLead()
    }
    if (event.name === 'Outsource') {
      this.isOutsourceLead = true
      this.getOutsourceLead()
    }
  }
  getTrainingLead() {
    this.apiService.getLeadsByTagId(1, 100, '63e39db72052e0098e18e00e', '63e396fe2052e0098e18def3', 'active').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.training_list = res.items
      }
    })
  }
  getTrainingLeadId(event) {
    this.select_training_lead
  }
  getOutsourceLead() {
    this.apiService.getOutsourceLeadsByTagId(1, 100, '63e396de2052e0098e18deec', '63e39dd62052e0098e18e015','').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.outsource_list = res.items
      }
    })
  }
  getOutsourceLeadId(event) {
    this.select_outsource_lead
  }
  getAllEmployee() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
        this.empList = res.items
        this.empList.push({name:'All',_id:'all'})
    })
  }
  getAllStudents() {
    this.apiService.getAllStudents(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.studentList = res.items
      }
    })
  }
  getAllBatch() {
    this.apiService.getBatchList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.batchList = res.data.items
      }
    })
  }
  getEmployeeCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
  getTaskPriorityList() {
    this.apiService.getTagByTagCatgoryId(this.task_priority_catId).subscribe((res: any) => {
      this.task_priority_List = res.data
      this.task_priority_List.push({displayname:'All',_id:'all'})
    })
  }
  getChangeTaskPriority(event) {
    this.selected_task_priority 
  }
  editTask(id) {
    this.route.navigate(['task/edit', id])
  }
  getTaskId(id: any) {
    this.taskId = id
    this.getTaskById()
  }
  getTaskById() {
    this.apiService.getTaskById(this.taskId).subscribe((res: any) => {
      this.taskDetail = res.data
    })
  }
   // --------------- Student ------------------------------------------------------------------
   toggleAllSelectionStudent() {
    this.selectedStudent = [];
    this.isAllSelected = !this.isAllSelected;
    this.studentList.forEach((item, index) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedStudent.push(item.id);
      }
      // Update the selected item count
      if (index < 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      } else if (index === 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      }
    });
  }
  toggleSelectionStudent(item) {
    if (item.selected) {
      this.selectedEmp.push(item.id);
    } else {
      const index = this.selectedStudent.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectedStudent.splice(index, 1);
      }
    }
    this.isAllSelected = this.studentList.every((emp) => emp.selected);
  }
  onDropdownOpenStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }

  onDropdownCloseStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }
    // --------------- Team ------------------------------------------------------------------

    toggleAllSelectionTeam() {
      this.selectTeam = [];
      this.isAllSelected = !this.isAllSelected;
      this.teamList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectTeam.push(item);
        }
      });
    }
  
    toggleSelectionTeam(item) {
      if (item.selected) {
        this.selectTeam.push(item);
        if (item != '') {
          this.apiService.getEmployeeByTeamId(item._id, 1, 100).subscribe((res: any) => {
            if (res.statusCode === 200) {
              this.isTeam_selected_list = true
              let data = res.items
              for (let item of data) {
                this.team_selected_list.push(item.user[0])
              }
              this.team_selected_list_data = this.team_selected_list.map(item => item._id)
            }
          })
        }
  
      } else {
        const index = this.selectTeam.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectTeam.splice(index, 1);
        }
      }
      this.isAllSelected = this.teamList.every((team) => team.selected);
    }
  
    onDropdownOpenTeam() {
      this.isAllSelected = this.teamList.every((item) => item.selected);
    }
  
    onDropdownCloseTeam() {
      this.isAllSelected = this.teamList.every((item) => item.selected);
    }
    // --------------- Employee ------------------------------------------------------------------
    toggleAllSelectionEmp() {
      this.selectedEmp = [];
      this.isAllSelected = !this.isAllSelected;
      this.empList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectedEmp.push(item._id);
        }
      });
    }
  
    toggleSelectionEmp(item) {
      if (item.selected) {
        this.selectedEmp.push(item._id);
      } else {
        const index = this.selectedEmp.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectedEmp.splice(index, 1);
        }
      }
      this.isAllSelected = this.empList.every((emp) => emp.selected);
    }
  
    onDropdownOpenEmp() {
      this.isAllSelected = this.empList.every((item) => item.selected);
    }
  
    onDropdownCloseEmp() {
      this.isAllSelected = this.empList.every((item) => item.selected);
    }
    // --------------- Batch ------------------------------------------------------------------
    toggleAllSelectionBatch() {
      this.selectedBatch = [];
      this.isAllSelected = !this.isAllSelected;
      this.batchList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectedBatch.push(item);
        }
      });
    }
  
    toggleSelectionBatch(item) {
      if (item.selected) {
        this.selectedBatch.push(item);
        if (item._id != '') {
          this.apiService.getEnrolmentsByBatchId(item._id,'').subscribe((res: any) => {
            if (res.statusCode === 200) {
              this.isBatch_selected_list = true
              this.batch_selected_list = res.data
              // for(let item of data){
              //   this.batch_selected_list.push(item.user[0])
              // }
              this.batch_selected_list_data = this.batch_selected_list.map(item => item._id)
            }
          })
        }
  
      } else {
        const index = this.selectedBatch.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectedBatch.splice(index, 1);
        }
      }
      this.isAllSelected = this.batchList.every((batch) => batch.selected);
    }
  
    onDropdownOpenBatch() {
      this.isAllSelected = this.batchList.every((item) => item.selected);
    }
  
    onDropdownCloseBatch() {
      this.isAllSelected = this.batchList.every((item) => item.selected);
    }
    onMenuItemClick(item: string) {
      item
      // Add your custom logic here
    }
    getTaskLabelList() {
      this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
        this.taskLabelList = res.data
        
      })
    }
    getChangeTaskLabelId(event) {
      this.selectedTaskLabel
    }
  
    getChangeScheduleId(event) {
      this.selectedSchedule_filter 
    }
    getChangeMandatoryId(event) {
      this.selectedMandatory 
    }
    createTask() {
  
      let body = {
        title: this.myForm.value.title,
        body: this.myForm.value.body,
        scheduleduration: this.myForm.value.due_date,
        working_hours: this.myForm.value.time,
        budget: this.myForm.value.budget,
        // type : '63e39db72052e0098e18e00e',
        type_projects: this.select_project,
        type_checklist: this.select_checklist,
        type_training: this.select_training_lead,
        type_outsource: this.select_outsource_lead,
        to: this.selectedStudent,
        priority: this.selected_task_priority,
        label: this.selectedTaskLabel,
        is_schedule: this.selectedSchedule,
        is_mandatory: this.selectedMandatory,
        stage: '64ae445ee0a6ff2e7db78317',
        status: '643e869259b78b65557d755a'
      }
      if (this.selectedStudent.length > 0) {
        body.to = this.selectedStudent
      }
      if (this.selectedBatch.length > 0) {
        body.to = this.batch_selected_list_data
      }
      if (this.selectedEmp.length > 0) {
        body.to = this.selectedEmp
      }
      if (this.selectTeam.length > 0) {
        body.to = this.team_selected_list_data
      }
      // console.log('form val',body)
      this.apiService.createTask(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success(res.message)
          // this.route.navigate(['/task/list'])
          this.modalService.dismissAll()
          this.setAndGetByStatus()
          // this.getTaskNormal()
          // this.getTaskMedium()
          // this.getTaskHigh()
          // this.getTaskUrgent()
  
        }
        else {
          this.toastr.error(res.error)
        }
      })
  
    }
    toggleActive(selected_item) {
      if (selected_item === 'emp-ind') {
        this.isEmpList = true;
        this.isTeamList = false
        this.isStudentList = false;
        this.isBatchList = false
      }
      else if (selected_item === 'emp-team') {
        this.isTeamList = true
        this.isEmpList = false;
        this.isStudentList = false;
        this.isBatchList = false
      }
      else if (selected_item === 'student-ind') {
        this.isStudentList = true;
        this.isBatchList = false
        this.isTeamList = false
        this.isEmpList = false;
  
      }
      else if (selected_item === 'student-batch') {
        this.isBatchList = true
        this.isStudentList = false;
        this.isTeamList = false
        this.isEmpList = false;
      }
    }
    toggleActiveStudent(name) {
      if (name === 'emp') {
        this.task_for_selected = 'employee'
        this.isEmployee = true;
        this.isEmpList = true
        this.isStudent = false;
        this.isStudentList = false
      }
      if (name === 'student') {
        this.task_for_selected = 'student'
        this.isStudent = true;
        this.isStudentList = true
        this.isEmpList = false
        this.isEmployee = false;
        this.isTeamList = false;
  
      }
    }
  

    updateTaskStatus(fromIndex, fromPriority, toIndex, toPriority) {
       
      if( fromIndex !='' && fromPriority !='' && toIndex !='' && toPriority !=''){
        let body = {
  
          moveFrom: fromIndex,
          moveTo: toIndex,
          priorityFrom: fromPriority,
          priorityTo: toPriority
      }
      this.apiService.taskOrderChange(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          // this.getTaskNormal()
          // this.getTaskMedium()
          // this.getTaskHigh()
          // this.getTaskUrgent()
        }
      })
      }
      
  
      // if (priority === 'normal') {
      //   this.badgeClass = 'info'
      // }
      // else if (priority === 'medium') {
      //   this.badgeClass2 = 'success'
      // }
      // else if (priority === 'high') {
      //   this.badgeClass3 = 'warning'
      // }
      // else if (priority === 'urgent') {
      //   this.badgeClass4 = 'danger'
      // }
  
      let currentTask: Task;
  
      // if (task) {
      //   currentTask = task;
      // }
      // else {
      //   currentTask = this.tasks.find(x => x.taskId === +id);
      // }
  
      // let index = this.tasks.indexOf(currentTask);
      // currentTask.status = status;
      // currentTask.badgeClass = badgeClass;
      // this.tasks.splice(index, 1, currentTask);
      // this.tasks = [...this.tasks];
      // this.loadTasks();
    }
    openDemoModal(content){
      const modalRef = this.modalService.open(content);
      // this.isDemotask_modal=true
      this.selectedTaskLabel='64749d694c173b1abc51e6c4'
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
    }
    getSelectedTask(id){
      this.isCurrentTask = true
      if(id){
        this.apiService.getTaskById(id).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.current_task_data = res?.data[0]
          }
        })
      }
  }
  updateStatus(status_id,task_id) {
    let body = {
      status:status_id
    }
    this.apiService.updateTask(task_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('update successfull')
        this.setAndGetByStatus()
      }
      else this.toastr.error(res.error)
    })
  }
  // ====
  getUserId(event){
      this.selected_user_id
  }
  getPriorityId(event){
      this.selected_priority_id 
  }
  getStageId(event){
      this.selected_stage_id   
  }

  saveFilter(){
    let body = {
      title: this.myForm.value.title,
      type_projects: this.select_project,
      type_outsource: this.select_outsource_lead,
      type_training: this.select_training_lead,
      type_checklist : this.select_checklist,
      // to: this.selectedStudent,
      // user_to: this.selectedEmp,
      priority: this.selected_task_priority,
      label: this.selectedTaskLabel,
      is_schedule: this.selectedSchedule_filter,
      is_mandatory: this.selectedMandatory,
      stage: '64ae445ee0a6ff2e7db78317',
      status: '643e869259b78b65557d755a',
      search: "all",
      page_no: 1,
      page_size: 50,
      filter_type: "",
      notes: "testing",
      admin_notes: "testing"
      // notes: this.myForm.value.notes,
      // admin_notes: this.myForm.value.admin_notes,

    }
    if(this.select_project){
      body.filter_type = "project"
    }
    if(this.select_outsource_lead){
      body.filter_type = "outsourcelead"
    }
    if(this.select_training_lead){
      body.filter_type = "traininglead"
    }
    if(this.select_training_lead){
      body.filter_type = "checklist"
    }
    // if (this.selectedStudent.length > 0) {
    //   body.to = this.selectedStudent
    // }
    // if (this.selectedBatch.length > 0) {
    //   body.to = this.batch_selected_list_data
    // }
    // if (this.selectedEmp.length > 0) {
    //   body.to = this.selectedEmp
    // }
    // if (this.selectTeam.length > 0) {
    //   body.to = this.team_selected_list_data
    // }
    this.apiService.createFilter(body).subscribe((res:any)=>{
        if(res?.isSuccess){
          this.toastr.success("saved filter")
          this.modalService.dismissAll();
          this.getCurrentUserFilter(this.user_id)
        }
        else this.toastr.error(res?.error)
      })

  }

  getCurrentUserFilter(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getFilterByUser(id).subscribe((res:any)=>{
      this.spinner.hide()
      this.saved_filter_list = res?.data.reverse();

      
    })
  }
  getSavedFilterId(data,index: number){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.activeFilterIndex = index
    let tab = this.task_status_list.find((item) => item._id == data?.status)
    this.activeTab = tab.name
      this.selected_user_id = data?.to
      this.selectedSchedule_filter = data?.is_schedule
      this.selected_stage_id = data?.stage
      this.selected_priority_id = data?.priority
      this.searchVal = data?.search
      this.apiService.getTaskDataByFilterId(data?._id,'','','','','','','','').subscribe((res:any)=>{
        this.spinner.hide()
        this.task_data = res?.data?.items
        this.total_count = res?.data?.totalCount
      })
  }

  openFilterModal(content){
    const modalOptions: NgbModalOptions = {
          size: 'lg', // 'sm', 'lg', or 'xl'
          backdrop: 'static',
        };
    const modalRef = this.modalService.open(content,modalOptions);

    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }

}
